export const BASE_OPTION_STYLES =
  'tw-w-full tw-min-h-4.8 tw-flex tw-items-center tw-cursor-pointer tw-px-2.4 tw-py-0.4 tw-font-body4 dark:tw-text-neutral-light-100 hover:tw-text-primary-light-500 dark:hover:tw-text-secondary-light-500 tw-transition-all';
